// /whats-new (2026-11-05): what we fixed and changed lately, one plain line each, newest first (GET /api/changelog:
// the last 60 days of shipped fixes; no names, no report text). Public: it loads before sign-in, like the legal pages.
import { ErrorNote, Spinner, useLoad } from "../components/bits";
import { byDay, changelog } from "../pipeline";
import { Link } from "../router";

const dayName = (iso: string) => {
  const d = new Date(`${iso}T12:00:00Z`);
  return Number.isNaN(d.getTime()) ? iso : d.toLocaleDateString("en-US", { month: "long", day: "numeric", year: d.getFullYear() === new Date().getFullYear() ? undefined : "numeric" });
};

export function WhatsNewScreen() {
  const { data, error, loading, reload } = useLoad(changelog, []);
  return (
    <main className="whats-new">
      <p>
        <Link to="/">CAO Studio</Link>
      </p>
      <h1>What's new</h1>
      <p className="muted">Fixes and changes from the last two months, many of them from your reports. Thank you.</p>
      {error && <ErrorNote text={`Couldn't load it. ${error}`} retry={reload} />}
      {loading && !data && <Spinner label="Loading" />}
      {data && !data.length && <p className="muted">Nothing yet. Check back soon.</p>}
      {data &&
        byDay(data).map((g) => (
          <section key={g.date}>
            <h2>{dayName(g.date)}</h2>
            <ul>
              {g.lines.map((l, i) => (
                <li key={i}>{l}</li>
              ))}
            </ul>
          </section>
        ))}
    </main>
  );
}
